
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.2,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="about" className="section bg-white" ref={sectionRef}>
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <h2 
            className={`text-3xl md:text-4xl font-bold text-center mb-12 text-developer-dark opacity-0 ${
              isVisible ? 'animate-fade-in' : ''
            }`}
          >
            {t('about.title')}
          </h2>
          
          <div className="space-y-6">
            <p 
              className={`text-developer-neutral text-lg opacity-0 ${
                isVisible ? 'animate-fade-in animate-delay-100' : ''
              }`}
            >
              {t('about.paragraph1')}
            </p>
            
            <p 
              className={`text-developer-neutral text-lg opacity-0 ${
                isVisible ? 'animate-fade-in animate-delay-200' : ''
              }`}
            >
              {t('about.paragraph2')}
              <span className="text-developer-dark font-medium"> {t('about.paragraph2FeatureBold1')}, {t('about.paragraph2FeatureBold2')}</span> et
              <span className="text-developer-dark font-medium"> {t('about.paragraph2FeatureBold3')}</span>.
              &nbsp;{t('about.paragraph3')}
            </p>
            
            <p 
              className={`text-developer-neutral text-lg opacity-0 ${
                isVisible ? 'animate-fade-in animate-delay-300' : ''
              }`}
            >
              {t('about.paragraph4')}
            </p>
            
            <div 
              className={`pt-8 opacity-0 ${
                isVisible ? 'animate-fade-in animate-delay-400' : ''
              }`}
            >
              <h3 className="text-xl font-medium text-developer-dark mb-4">{t('about.subtitle')}</h3>
              <ul className="grid md:grid-cols-2 gap-4">
                {(t('about.qualities', { returnObjects: true }) as string[]).map((item, index) => (
                  <li key={index} className="flex items-start">
                    <svg className="w-5 h-5 text-developer-accent mt-1 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-developer-neutral">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
